/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetMyOffersForSelectionDesktopRequest,
  TGetMyOffersForSelectionDesktopModel,
  IMappers,
  TGetMyOffersForSelectionDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetMyOffersForSelectionResponse } from '../../entities/get_my_offers_for_selection/GetMyOffersForSelectionResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetMyOffersForSelectionDesktopModel(
  parameters: IGetMyOffersForSelectionDesktopRequest,
): TGetMyOffersForSelectionDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/get-my-offers-for-selection-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetMyOffersForSelectionDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMyOffersForSelectionDesktopRequest;
}

export async function fetchGetMyOffersForSelectionDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMyOffersForSelectionDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetMyOffersForSelectionDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetMyOffersForSelectionDesktopModel(parameters),
    config,
  )) as FetchResponse<TGetMyOffersForSelectionDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMyOffersForSelectionResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetMyOffersForSelectionDesktopResponse>;
}
